import { define } from '../../define.js';
import { Rating } from './rating.js';
export * from './rating.js';
define('rating', Rating);
